<template>
  <div>
    <Head title="Orders" />
    <h1 class="mb-8 text-3xl font-bold" id="pg-tittle">Cancelled Orders</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Canceled Reason:</label>
        <select v-model="form.canceled_reason" class="form-select mt-1 w-full">
          <option v-for="(value, key) in cancel_reasons" :value="key" :selected="key === form.canceled_reason">{{value}}</option>
        </select>
      </search-filter>
      <Datepicker v-model="form.canceled_date" class="mr-4 w-full max-w-md" range :enable-time-picker="false" :partial-range="false">
      </Datepicker>
      <Link class="btn-indigo" href="/orders/create" v-if="false">
        <span>Sync</span>
        <span class="hidden md:inline">&nbsp;Orders</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-1 pt-6 px-3">Order ID</th>
            <th class="pb-1 pt-6 px-3">Date/Time</th>
            <th class="pb-1 pt-6 px-3">Customer</th>
            <th class="pb-1 pt-6 px-3">Order Value</th>
<!--            <th class="pb-2 pt-6 px-3">Deliver To</th>-->
            <th class="pb-1 pt-6 px-3">Email</th>
            <th class="pb-1 pt-6 px-3">Phone</th>
            <th class="pb-1 pt-6 px-3">Status</th>
            <th class="pb-1 pt-6 px-3">Cancel Reason</th>
            <th class="pb-1 pt-6 px-3"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="order in orders.data" :key="order.id" class="hover:bg-gray-100 focus-within:bg-gray-100" :id="`order_${order.id}`">
            <td class="border-t">
              <Link class="flex items-center px-3 py-4 focus:text-indigo-500" :href="`/orders/${order.id}`">
                <a href="">{{ order.order_id }}</a>
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-3 py-4 focus:text-indigo-500" :href="`/orders/${order.id}`">
                {{ order.date_time }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-3 py-4 focus:text-indigo-500" :href="`/orders/${order.id}`">
                {{ order.name }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-3 py-4" :href="`/orders/${order.id}`" tabindex="-1">
                ₹ {{ order.value }}
              </Link>
            </td>
<!--            <td class="border-t">-->
<!--              <Link class="flex items-center px-3 py-4 leading-6" :href="`/orders/${order.id}`" tabindex="-1">-->
<!--                {{ order.shipping_address.city }}<br>-->
<!--                {{ order.shipping_address.state }} {{ order.shipping_address.postcode }}-->
<!--              </Link>-->
<!--            </td>-->
            <td class="border-t">
              <Link class="flex items-center px-3 py-4" :href="`/orders/${order.id}`" tabindex="-1">
                {{order.email}}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-3 py-4" :href="`/orders/${order.id}`" tabindex="-1">
                {{order.phone_number}}
              </Link>
            </td>
            <td class="border-t">
              <span class="flex items-center px-3 py-4">
                <span class="pill_blue" v-if="order.status == 'pending'">Pending</span>
                <span class="pill_green" v-if="order.status == 'confirmed'">Confirmed</span>
                <span class="pill_red" v-if="order.status == 'cancelled'">Cancel Pending</span>
                <span class="pill_yellow" v-if="order.status == 'followup'">Followup</span>
              </span>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-3 py-4" :href="`/orders/${order.id}`" tabindex="-1">
                {{order.cancel_reason}}
              </Link>
            </td>
            <td class="w-px border-t">
              <Link class="flex items-center px-4" :href="`/orders/${order.id}`" tabindex="-1">
                <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              </Link>
            </td>
          </tr>
          <tr v-if="orders.data.length === 0">
            <td class="px-3 py-4 border-t" colspan="4">No orders found.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="orders.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import { ref } from 'vue';
import { Inertia } from '@inertiajs/inertia'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import axios from "axios";
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import { endOfMonth, endOfYear, startOfMonth, startOfYear, subMonths } from 'date-fns';

export default {
  created() {
    let params = (new URL(document.location)).searchParams;
    let status = params.get("status");
    let unassigned = params.get("unassigned");
    let all = params.get("all");

    if(status && status === 'pending') {
      this.title = "Pending Orders";
      return;
    }

    if(status && status === 'followup') {
      this.title = "Orders to Followup";
      return;
    }

    if(unassigned) {
      this.title = "Orders to Assign";
      return;
    }

    if(all) {
      this.title = "All Orders";
    }

  },
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
    Datepicker,
  },
  layout: Layout,
  props: {
    filters: Object,
    orders: Object,
    users: Array,
    assigned_to: Array,
    admin: Boolean,
    cancel_reasons: Array
  },
  data() {

    const presetRanges = ref([
      { label: 'Today', range: [new Date(), new Date()] },
      { label: 'This month', range: [startOfMonth(new Date()), endOfMonth(new Date())] },
      {
        label: 'Last month',
        range: [startOfMonth(subMonths(new Date(), 1)), endOfMonth(subMonths(new Date(), 1))],
      },
      { label: 'This year', range: [startOfYear(new Date()), endOfYear(new Date())] },
      {
        label: 'This year (slot)',
        range: [startOfYear(new Date()), endOfYear(new Date())],
        slot: 'yearly',
      },
    ]);

    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
        canceled_date: this.filters.date ?? [startOfMonth(new Date()), new Date()],
        canceled_reason : this.filters.canceled_reason
      },
      assign: {
        order_id: null,
        user_id: null,
      },
      presetRanges
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/orders/cancelled', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    assign_user(order_id, user_id) {

      let params = (new URL(document.location)).searchParams;
      let unassigned = params.get("unassigned");

      if(unassigned) {
        this.$inertia.post('/orders/'+order_id+'/assign', {'user_id' : user_id});
        return;
      }

      //this.$inertia.put('/orders/'+order_id+'/assign', {'user_id' : user_id});
      var url =  '/orders/'+order_id+'/assign';
      axios({
        method: 'post',
        url:url,
        data: {'user_id' : user_id}
      }).then(function (response) {
        document.getElementById('order_'+order_id).classList.remove("hover:bg-gray-100");
        document.getElementById('order_'+order_id).classList.remove("focus-within:bg-gray-100");
        document.getElementById('order_'+order_id).classList.add("bg-green-100");

        setTimeout(() => {
          document.getElementById('order_'+order_id).classList.remove("bg-green-100");
          document.getElementById('order_'+order_id).classList.add("hover:bg-gray-100");
          document.getElementById('order_'+order_id).classList.add("focus-within:bg-gray-100");
        },1000);
      }).catch(function (error) {
        alert("Failed to save update. Please try again.");
        this.$inertia.reload({ only: ['orders', 'main-menu'] });
      });
    }
  },
}
</script>
